import {
  CompaniesResponse,
  DominResponse,
  ModuleResponse,
  QuestionsAvailabilityResponse,
  QuestionBankResponse,
  QuestionBankSectionResponse,
  QuestionTypeResponse
} from '../../redux/Slices/QuestionBankSlice/types';
import api from '../api';

type BaseQueryParams = {
  page: number;
  size: number;
};

type CompanyQueryParams = BaseQueryParams & {
  companyId: string;
};

export const questionBankApi = api.injectEndpoints({
  endpoints: builder => ({
    getQuestionBankQuestions: builder.query<
      QuestionBankResponse,
      BaseQueryParams
    >({
      query: ({ page, size }: BaseQueryParams) => ({
        url: '/api/question/getallquestions',
        method: 'GET',
        params: { page, size }
      })
    }),
    getQuestionsByCompanyId: builder.query<
      QuestionBankResponse,
      CompanyQueryParams
    >({
      query: ({ companyId, page, size }: CompanyQueryParams) => ({
        url: '/api/question/getallquestionsbycompanyid',
        method: 'GET',
        params: { companyId, page, size }
      })
    }),
    getAllCompanies: builder.query<CompaniesResponse, void>({
      query: () => ({
        url: '/api/company/all',
        method: 'GET'
      })
    }),
    getAllQuestionTypes: builder.query<QuestionTypeResponse, void>({
      query: () => ({
        url: '/api/questiontype/fetchall',
        method: 'GET'
      })
    }),
    getAllDomains: builder.query<DominResponse, void>({
      query: () => ({
        url: '/api/domine/all',
        method: 'GET'
      })
    }),
    getAllModules: builder.query<ModuleResponse, void>({
      query: () => ({
        url: '/api/module/all',
        method: 'GET'
      })
    }),
    getQuestionBankData: builder.query<QuestionBankSectionResponse, void>({
      query: () => ({
        url: '/api/cms/question/sections/topics/available',
        method: 'GET'
      })
    }),
    getQuestionsAvailability: builder.mutation<
      QuestionsAvailabilityResponse,
      { topicIds: string[]; questionsCount: number }
    >({
      query: body => ({
        url: '/api/cms/question/data/availability',
        method: 'POST',
        body
      })
    }),
    getQuestionBankFilter: builder.mutation({
      query: payload => ({
        url: '/api/cms/questionbank/filter',
        method: 'POST',
        body: payload
      })
    })
  })
});

export const {
  useGetQuestionBankQuestionsQuery,
  useGetQuestionsByCompanyIdQuery,
  useGetAllCompaniesQuery,
  useGetAllQuestionTypesQuery,
  useGetAllDomainsQuery,
  useGetAllModulesQuery,
  useGetQuestionBankDataQuery,
  useGetQuestionBankFilterMutation,
  useGetQuestionsAvailabilityMutation
} = questionBankApi;
